import { Outlet, createFileRoute } from "@tanstack/react-router";

import { APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_TO.PROFILE)({
    component: ProfileLayout,
    staticData: {
        config: {
            title: "profile",
        },
    },
});

function ProfileLayout() {
    return <Outlet />;
}
